import { ErrorToast } from '../components/error-toast';
import { createStandaloneToast } from '@chakra-ui/react';
import axios from 'axios';
import { object, string } from 'yup';
import { ERROR_MESSAGES } from '@lon/shared/constants';
import { hashValue, patchLocalStorage } from '@lon/shared/utils';
import {
  ErrorResponse,
  LoginState,
  OnSubmitProps,
  SuccessResponse,
} from './types';
import { APPLICATION, MnLoginErrorCodes } from './constants';

export const getValidation = (isMFARequired?: boolean) => {
  const validationSchema = object({
    username: string()
      .trim()
      .required('Username is a required field')
      .default(''),
    password: string()
      .trim()
      .required('Password is a required field')
      .default(''),
    ...(isMFARequired && {
      mfaCode: string()
        .trim()
        .required('"Verification Code" is a required field'),
    }),
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({}),
  };
};

export const onSubmit = async ({
  password,
  username,
  mfaCode,
  district,
  eventCode,
  isMFA,
  onSuccess,
  setLoginState,
  sendLoginPath,
}: OnSubmitProps) => {
  try {
    const {
      data: { data },
    } = await axios.post<SuccessResponse>(
      `${process.env.NX_REACT_APP_LOGIN_API}${isMFA ? '/mfa' : ''}`,
      new URLSearchParams({
        username,
        password,
        district: typeof district === 'string' ? district : district?.value,
        application: APPLICATION,
        ...(mfaCode && { code: mfaCode }),
        ...(sendLoginPath && { loginPath: window.location.pathname }),
      })
    );

    localStorage.setItem(
      'availableSuites',
      JSON.stringify(data?.applicationsNames)
    );

    const userId = (data?.user?.userId as any)?.value;

    hashValue(userId).then((value) => {
      localStorage.setItem('signature', value);
      patchLocalStorage('lastDistrictBySignature', {
        [value]: {
          ...(typeof district === 'object' ? district : { value: district }),
          ...(eventCode && {
            adoptionEventCode: eventCode,
          }),
        },
      });
    });

    localStorage.setItem(
      'availableSuites',
      JSON.stringify(data?.applicationsNames)
    );

    onSuccess(data.user);
  } catch (error) {
    const { toast } = createStandaloneToast();

    if (axios.isAxiosError(error) && error.response) {
      const backendError = error as ErrorResponse;

      if (error.response.status < 500 && error.response.status !== 0) {
        const { code = 'GENERAL_ERROR' } =
          backendError?.response?.data.error || {};
        const message = ERROR_MESSAGES[code];

        if (code === MnLoginErrorCodes.MFA_REQUIRED) {
          setLoginState?.(LoginState.MFA);
          return;
        } else if (
          code === MnLoginErrorCodes.INVALID_CREDENTIALS ||
          code === MnLoginErrorCodes.ACCOUNT_DEACTIVATED
        ) {
          toast({
            title: message.trim(),
            status: 'error',
            isClosable: true,
            duration: null,
            render: ({ onClose }) => (
              <ErrorToast message={message} onClose={onClose} />
            ),
          });
          return;
        } else {
          toast({ title: message.trim(), status: 'error', isClosable: true });
          return;
        }
      }
    }
    toast({
      title: ERROR_MESSAGES.GENERAL_ERROR,
      status: 'error',
      isClosable: true,
    });
  }
};
